import { Dayjs } from 'dayjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd-modern/es/date-picker/generatePicker';
import generateCalendar from 'antd-modern/es/calendar/generateCalendar';

export const PickerAdapter = generatePicker<Dayjs>(dayjsGenerateConfig);
export const CalendarAdapter = generateCalendar<Dayjs>(dayjsGenerateConfig);
